import { ItemTop10 } from '@/types/friendCup';
import { cn, formatNumberToLocale } from '@/utils/functions';

export const ItemTop = ({ team }: { team: ItemTop10 }) => {
  return (
    <div className="px-4 lg:px-0">
      <div className="flex justify-stretch items-center bg-white border-b-gdt-gray-6 border-b-[1px] lg:py-6 text-sm font-semibold text-gdt-gray-3 py-4">
        <div className="w-14 lg:w-[104px]">
          <div
            className={cn(
              'rounded-full bg-gdt-blue text-white w-9 h-9 lg:w-10 lg:h-10 font-bold text-lg flex justify-center items-center mx-auto',
              { 'text-gdt-blue bg-gdt-blue-light2': team.puesto !== 1 }
            )}
          >
            <span>{team.puesto}</span>
          </div>
        </div>
        <div className="flex-1 space-y-1 pl-1">
          <p className="font-bold text-gdt-gray">{team.nombreGrupo}</p>
        </div>
        <p className="w-[87px] lg:w-[183px] text-center lg:text-lg lg:text-gdt-gray lg:font-bold">
          {team.puntos && formatNumberToLocale(team.puntos)}
        </p>
      </div>
    </div>
  );
};
